import { gsap } from "gsap";
import Alpine from "alpinejs";

Alpine.data('modal', () => ({
  isOpen: false,
  open() {
    this.isOpen = true;
  },
  close() {
    this.isOpen = false;
  },
}));